import { render, staticRenderFns } from "./NovoAnexo.vue?vue&type=template&id=3191514e"
import script from "./NovoAnexo.vue?vue&type=script&lang=js"
export * from "./NovoAnexo.vue?vue&type=script&lang=js"
import style0 from "./NovoAnexo.vue?vue&type=style&index=0&id=3191514e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports